var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCertificate = function SvgCertificate(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 3.96875 6.3500002",
    height: 24,
    width: 15,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-290.64998)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.2952775,0.05011304)",
    id: "g5592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5564",
    transform: "translate(3.2513052,0.07168202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5546",
    d: "m -6.5432699,290.54921 -0.6283854,0.53537 -0.8221721,0.0656 -0.065629,0.82269 -0.5353677,0.62787 0.5353677,0.62786 0.065629,0.82269 0.8221721,0.0656 0.6283854,0.53537 0.6278687,-0.53537 0.8226888,-0.0656 0.065629,-0.82269 0.5348509,-0.62786 -0.5348509,-0.62787 -0.065629,-0.82269 -0.8226888,-0.0656 z m 0.00103,0.71055 a 1.3285826,1.3285826 0 0 1 1.3286012,1.3286 1.3285826,1.3285826 0 0 1 -1.3286012,1.3286 1.3285826,1.3285826 0 0 1 -1.328601,-1.3286 1.3285826,1.3285826 0 0 1 1.328601,-1.3286 z",
    style: {
      fill: "#0ab912",
      fillOpacity: 1,
      strokeWidth: 0.29011387
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "text5559",
    y: 293.37225,
    x: -6.9615908,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "2.11666656px",
      lineHeight: 1.25,
      fontFamily: "serif",
      InkscapeFontSpecification: "serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#0ab912",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "2.11666656px",
      fontFamily: "serif",
      InkscapeFontSpecification: "serif",
      fill: "#0ab912",
      fillOpacity: 1,
      strokeWidth: 0.26458332
    },
    y: 293.37225,
    x: -6.9615908,
    id: "tspan5557"
  }, "I"))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0ab912",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.29311299px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m -4.1039428,294.08837 v 2.91042 l 0.810149,-0.79375 0.8134459,0.79375 v -2.91042 z",
    id: "path5566"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCertificate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "certificate.ed71b6047a1e98345b9838ceaeab30ad.svg";